
















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ProductTab } from '@/models/Product';
import TabsLandscape from './TabsLandscape.vue';
import TabsPortrait from './TabsPortrait.vue';
import { ProductVariants } from '@/models/Product';

@Component({
    components: {
        TabsLandscape,
        TabsPortrait
    }
})
export default class ProductTabs extends Vue {
    protected productTabs: ProductTab[];

    protected productItemNumber!: string;

    constructor() {
        super();

        this.productTabs = JSON.parse(this.$attrs['data-product-tabs']);
        this.productItemNumber = this.$attrs['data-product-itemnumber'];

        // console.log(this.productTabs);
        this.$attrs['data-product-tabs'] = '';
    }
}
